module.exports = __webpack_public_path__ + "static/media/2.e8786d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/2.png
// module id = 491
// module chunks = 0